import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { TimesIcon } from '../Icons';
import { Link } from '../Link';
import { Focusable } from '../Focusable';
import { keyCodes } from '../../common/constants';

const Tab = ({ className, classNames, variant, selected, value, label, tabIndex, onClose, onChange }) => {
    const handleClick = e => {
        e.preventDefault();

        if (onChange) {
            onChange(value.toString());
        }
    };

    const handleTabClose = e => {
        e.preventDefault();
        e.stopPropagation();

        onClose(value);
    };

    const handleXButtonKeyDown = e => {
        if (e.keyCode === keyCodes.ENTER_KEY) {
            handleTabClose(e);
        }
    };

    const rootClassName = `onsolve-${variant}__item`;
    const linkClassName = `onsolve-${variant}__link`;
    const closeIconClassName = `onsolve-${variant}__close`;

    const rootClassNames = classnames(
        rootClassName,
        { [`${rootClassName}--active`]: selected },
        className,
        classNames.rootClass
    );
    const linkClassNames = classnames(linkClassName, { [`${linkClassName}--active`]: selected }, classNames.linkClass);

    return (
        <li className={rootClassNames} tabIndex="-1">
            <Link className={linkClassNames} onClick={handleClick} tabIndex={tabIndex}>
                {label}
                {onClose && (
                    <Focusable
                        render={({ classes }) => (
                            <TimesIcon
                                tabIndex={selected ? 0 : -1}
                                size="xs"
                                className={classnames(closeIconClassName, classes)}
                                onClick={handleTabClose}
                                onKeyDown={handleXButtonKeyDown}
                            />
                        )}
                    />
                )}
            </Link>
        </li>
    );
};

Tab.propTypes = {
    className: PropTypes.string,
    classNames: PropTypes.object,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onChange: PropTypes.func,
    onClose: PropTypes.func,
    selected: PropTypes.bool,
    tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.any,
    variant: PropTypes.oneOf(['tabs', 'pills', 'separated'])
};

Tab.defaultProps = {
    variant: 'tabs',
    classNames: {}
};

Tab.displayName = 'Tab';

export default Tab;
